import { API } from "../api";

const BASE_URL = "/members/transaction_histories";

export const memberTransactionHistoryApi = API.injectEndpoints({
  endpoints: (builder) => ({
    // Get all transaction history for member
    // Supports filtering by transaction type (CONTRIBUTION, LOAN, WITHDRAWAL, REGISTRATION_FEE, or 'all')
    // Supports search and pagination
    getMemberTransactionHistory: builder.query({
      query: ({ page = 1, limit = 20, payment_type = "all", search = "" }) => {
        const params = new URLSearchParams({
          guard: "member",
          page: page.toString(),
          limit: limit.toString(),
        });

        // Add payment_type filter (exclude SMS_TOPUP for members)
        if (payment_type && payment_type !== "all") {
          params.append("payment_type", payment_type);
        }

        // Add search if provided
        if (search) {
          params.append("search", search);
        }

        return {
          url: `${BASE_URL}?${params.toString()}`,
        };
      },
      transformResponse: (responseData) => {
        return {
          transactions: responseData?.data?.histories || [],
          pagination: responseData?.data?.pagination || null,
        };
      },
      providesTags: (result, error, arg) => [
        { type: "member-transaction-history", id: arg.payment_type || "all" },
      ],
    }),

    // Get single transaction details
    getMemberTransactionById: builder.query({
      query: (recordId) => ({
        url: `${BASE_URL}/${recordId}/view?guard=member`,
      }),
      transformResponse: (responseData) => {
        // Backend returns: { status: true, message: "...", data: [{...}] }
        // We need to extract the first element from the data array
        const data = responseData?.data;
        
        // If data is an array, return the first element
        if (Array.isArray(data)) {
          return data.length > 0 ? data[0] : null;
        }
        
        // If data is already an object (shouldn't happen but handle it)
        if (data && typeof data === 'object' && data.id) {
          return data;
        }
        
        // Fallback
        return null;
      },
      providesTags: (result, error, arg) => [
        { type: "member-transaction-history", id: arg },
      ],
    }),
  }),
});

export const {
  useGetMemberTransactionHistoryQuery,
  useGetMemberTransactionByIdQuery,
} = memberTransactionHistoryApi;

